"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeaconTransport = void 0;
var BeaconTransport = /** @class */ (function () {
    function BeaconTransport(url, sendBeacon) {
        if (sendBeacon === void 0) { sendBeacon = function (_url, data) {
            return window.navigator.sendBeacon(_url, data);
        }; }
        this.url = url;
        this.sendBeacon = sendBeacon;
    }
    BeaconTransport.prototype.send = function (data) {
        this.sendBeaconRequest(JSON.stringify(data));
    };
    BeaconTransport.prototype.sendBeaconRequest = function (data) {
        this.sendBeacon(this.url, data);
    };
    BeaconTransport.hasBrowserSupport = function () {
        return (typeof window !== 'undefined' &&
            window.navigator &&
            typeof window.navigator.sendBeacon !== 'undefined');
    };
    return BeaconTransport;
}());
exports.BeaconTransport = BeaconTransport;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmVhY29uVHJhbnNwb3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiQmVhY29uVHJhbnNwb3J0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBO0lBQ0kseUJBQ3FCLEdBQVcsRUFDWCxVQUMwQjtRQUQxQiwyQkFBQSxFQUFBLHVCQUF3QixJQUFZLEVBQUUsSUFBWTtZQUMvRCxPQUFBLE1BQU0sQ0FBQyxTQUFTLENBQUMsVUFBVSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUM7UUFBdkMsQ0FBdUM7UUFGMUIsUUFBRyxHQUFILEdBQUcsQ0FBUTtRQUNYLGVBQVUsR0FBVixVQUFVLENBQ2dCO0lBQzVDLENBQUM7SUFFRyw4QkFBSSxHQUFYLFVBQVksSUFBb0M7UUFDNUMsSUFBSSxDQUFDLGlCQUFpQixDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztJQUNqRCxDQUFDO0lBRU8sMkNBQWlCLEdBQXpCLFVBQTBCLElBQVk7UUFDbEMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ3BDLENBQUM7SUFFYSxpQ0FBaUIsR0FBL0I7UUFDSSxPQUFPLENBQ0gsT0FBTyxNQUFNLEtBQUssV0FBVztZQUM3QixNQUFNLENBQUMsU0FBUztZQUNoQixPQUFPLE1BQU0sQ0FBQyxTQUFTLENBQUMsVUFBVSxLQUFLLFdBQVcsQ0FDckQsQ0FBQztJQUNOLENBQUM7SUFDTCxzQkFBQztBQUFELENBQUMsQUF0QkQsSUFzQkM7QUF0QlksMENBQWUifQ==